import React, { Component } from "react";

const NewLinkButton = ({ onClick }) => (
    <button className="btn btn-primary btn-md push-button right-alligned lowered"
        id="newLink"
        onClick={onClick}
        tabIndex="-1">Add Another Site
    </button>
);


export default NewLinkButton;
